/**
 * The type of a device running Harmony.
 */
export var DeviceType;
(function (DeviceType) {
    DeviceType["UNKNOWN"] = "unknown";
    DeviceType["COMPUTER"] = "computer";
    DeviceType["TABLET"] = "tablet";
    DeviceType["SMARTPHONE"] = "smartphone";
    DeviceType["SPEAKER"] = "speaker";
    DeviceType["TV"] = "tv";
    DeviceType["AVR"] = "avr";
    DeviceType["STB"] = "stb";
    DeviceType["AUDIO_DONGLE"] = "audio_dongle";
    DeviceType["GAME_CONSOLE"] = "game_console";
    DeviceType["CAST_VIDEO"] = "cast_video";
    DeviceType["CAST_AUDIO"] = "cast_audio";
    DeviceType["AUTOMOBILE"] = "automobile";
    DeviceType["SMARTWATCH"] = "smartwatch";
    DeviceType["CHROMEBOOK"] = "chromebook";
})(DeviceType || (DeviceType = {}));
//# sourceMappingURL=device_type.js.map